import { MandatoryAmountValidator } from '@src/common/fields/AmountValidator';
import type { NumberSchema } from 'yup';

export class AmountField {
  public static fieldName = 'preauthorizeAmount' as const;
  public static validator: NumberSchema = MandatoryAmountValidator;
}
